/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { Module } from '@msdyn365-commerce-modules/utilities';
import { IDlvryProductSheetViewProps } from './dlvry-product-sheet';
import { FilePdf } from '../../components/icons/file-pdf';

export default (props: IDlvryProductSheetViewProps) => {
    const { resources, ProductSheet, className, onDownloadProductSheet } = props;

    return (
        <Module {...ProductSheet}>
            <button className={`${className}__download-button`} onClick={onDownloadProductSheet}>
                <FilePdf width={22.39} height={22.39} />
                <span>{resources.productSheetButtonText}</span>
            </button>
        </Module>
    );
};
